import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { loginReducer, logoutReducer } from './slices/authSlice';
import demographicsReducer from './slices/demographicsSlice';
import menuEnhancementReducer from './slices/menuEnhancementSlice';
import reviewAnalysisReducer from './slices/reviewAnalysisSlice';
import competitorPromotionReducer from './slices/competitorPromotionSlice';
import competitorsReducer from './slices/competitorsSlice';
import upcomingEventsReducer from './slices/upcomingEventsSlice';
import menuItemsReducer from './slices/menuItemsSlice';
import eventUploadReducer from './slices/eventUploadSlice';
import scheduledCampaignsReducer from './slices/scheduledCampaignsSlice';
import campaignGenerationReducer from './slices/campaignGenerationSlice';
import generatedIdeasReducer from './slices/generatedIdeasSlice';
import workflowTriggerReducer from './slices/workflowTriggerSlice';
import integrationsReducer from './slices/integrationsSlice';
import cloverReducer from './slices/cloverSlice';
import weeklyIdeasReducer from './slices/weeklyIdeasSlice';
import seasonalIdeasReducer from './slices/seasonalIdeasSlice';
import competitiveIdeasReducer from './slices/competitiveIdeasSlice';
import contentGenerationReducer from './slices/contentGenerationSlice';
import postNowReducer from './slices/postNowSlice';
import scheduleCampaignReducer from './slices/scheduleCampaignSlice';
import restaurantReducer from './slices/restaurantSlice';
import socialMediaPostsReducer from './slices/socialMediaPostsSlice';
import pexelsReducer from './slices/pexelsSlice';
import imageUploadReducer from './slices/imageUploadSlice';
import campaignCreationReducer from './slices/campaignCreationSlice';
import mediaCaptionReducer from './slices/mediaCaptionSlice';
import campaignAnalyticsReducer from './slices/campaignAnalyticsSlice';
import campaignPostsAnalyticsReducer from './slices/campaignPostsAnalyticsSlice';
import campaignsReducer from './slices/campaignsSlice';
import facebookPagesReducer from './slices/facebookPagesSlice';
import customersReducer from './slices/customersSlice';
import campaignScheduleReducer from './slices/campaignScheduleSlice';
import marketingCampaignReducer from './slices/marketingCampaignSlice';
import templatesLibraryReducer from './slices/templatesLibrarySlice';
import rootSaga from './sagas/rootSaga';

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Configure store
export const store = configureStore({
  reducer: {
    auth: loginReducer,
    logoutData: logoutReducer,
    demographics: demographicsReducer,
    menuEnhancement: menuEnhancementReducer,
    reviewAnalysis: reviewAnalysisReducer,
    competitorPromotion: competitorPromotionReducer,
    competitors: competitorsReducer,
    upcomingEvents: upcomingEventsReducer,
    menuItems: menuItemsReducer,
    eventUpload: eventUploadReducer,
    scheduledCampaigns: scheduledCampaignsReducer,
    campaignGeneration: campaignGenerationReducer,
    generatedIdeas: generatedIdeasReducer,
    workflowTrigger: workflowTriggerReducer,
    integrations: integrationsReducer,
    clover: cloverReducer,
    weeklyIdeas: weeklyIdeasReducer,
    seasonalIdeas: seasonalIdeasReducer,
    competitiveIdeas: competitiveIdeasReducer,
    contentGeneration: contentGenerationReducer,
    postNow: postNowReducer,
    scheduleCampaign: scheduleCampaignReducer,
    restaurant: restaurantReducer,
    socialMediaPosts: socialMediaPostsReducer,
    pexels: pexelsReducer,
    imageUpload: imageUploadReducer,
    campaignCreation: campaignCreationReducer,
    mediaCaption: mediaCaptionReducer,
    campaignAnalytics: campaignAnalyticsReducer,
    campaignPostsAnalytics: campaignPostsAnalyticsReducer,
    campaigns: campaignsReducer,
    facebookPages: facebookPagesReducer,
    customers: customersReducer,
    campaignSchedule: campaignScheduleReducer,
    marketingCampaign: marketingCampaignReducer,
    templatesLibrary: templatesLibraryReducer
    // Add other reducers here as you create them
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

// Run the root saga
sagaMiddleware.run(rootSaga);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
